angular.module('FlexyBeautyApp.services')
    .factory('SalePaymentType', ['gettextCatalog', 'Brand', function (gettextCatalog, Brand) {
        return {
            CASH: {
                type: "CASH",
                label: gettextCatalog.getString("Espèces"),
                labelChartPayment: gettextCatalog.getString("Espèces"),
                keyPrice: "cashPrice",
                keyNumber: "cashNb"
            },
            CB: {
                type: "CB",
                label: gettextCatalog.getString("Carte bancaire"),
                labelChartPayment: gettextCatalog.getString("CB"),
                keyPrice: "cbPrice",
                keyNumber: "cbNb"
            },
            CBONLINE: {
                type: "CBONLINE",
                label: gettextCatalog.getString("Carte bancaire"),
                labelChartPayment: gettextCatalog.getString("CB Online"),
                keyPrice: "cbOnlinePrice",
                keyNumber: "cbOnlineNb"
            },
            CHECK: {
                type: "CHECK",
                label: gettextCatalog.getString("Chèque"),
                labelChartPayment: gettextCatalog.getString("Chèques"),
                keyPrice: "checkPrice",
                keyNumber: "checkNb"
            },
            GIFT: {
                type: "GIFT",
                label: gettextCatalog.getString("Bon cadeau"),
                labelChartPayment: gettextCatalog.getString("Chq cadeaux"),
                keyPrice: "giftPrice",
                keyNumber: "giftNb"
            },
            OTHER: {
                type: "OTHER",
                label: gettextCatalog.getString("Autre"),
                labelChartPayment: gettextCatalog.getString("Autres"),
                keyPrice: "otherPrice",
                keyNumber: "otherNb"
            },
            UNPAID: {
                type: "UNPAID",
                label: gettextCatalog.getString("Reste à payer"),
                labelChartPayment: "",
                keyPrice: "unpaidPrice",
                keyNumber: "unpaidNb"
            },
            IZETTLE: {
                type: "IZETTLE",
                label: gettextCatalog.getString("Carte bancaire"),
                labelChartPayment: gettextCatalog.getString("CB iZettle"),
                keyPrice: "iZettlePrice",
                keyNumber: "iZettleNb"
            },
            LECISEAU: {
                type: "LECISEAU",
                label: Brand.marketplace.url.shortWebsite,
                labelChartPayment: Brand.marketplace.url.shortWebsite,
                keyPrice: "leCiseauPrice",
                keyNumber: "leCiseauNb"
            }
        };
    }])

    .factory('SalePaymentTypeFactory', ['SalePaymentType', function (SalePaymentType) {
        return {
            from: function (type) {
                for (let salePaymentType in SalePaymentType) {
                    if (SalePaymentType.hasOwnProperty(salePaymentType) && SalePaymentType[salePaymentType].type === type) {
                        return SalePaymentType[salePaymentType];
                    }
                }
            }
        };
    }]);



// WEBPACK FOOTER //
// ./js/services/views/ConstantsSalePaymentType.js